












































import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { getLiveUrl } from "@/lib/urlHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import LivePreviewItem from "@/components/LivePreviewItem";

export default defineComponent({
  name: "DiscoverLivePreviews",
  components: { BaseButton, BaseIcon, CustomScroll, LivePreviewItem },
  props: {
    users: { type: Array as PropType<UserPublicData[]>, default: () => [] },
  },
  setup() {
    const isCreatorInPrivate = (user: UserPublicData) =>
      !!user.publicLivechatUser && !user.publicLivechatUser.broadcasting;

    return { getLiveUrl, isCreatorInPrivate };
  },
});
